/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react'
import { Grid, Paper, Typography, IconButton } from '@mui/material'
import DeleteIcon from '@mui/icons-material/Delete'
import type { UserListItem } from '../../interfaces/IWarehouseForm'
import { useLang } from '~/hooks/useLang'

interface OperatorsListProps {
  readonly operatorsList: readonly UserListItem[]
  readonly onRemove: (userId: number) => void
}

export default function OperatorsList({
  operatorsList,
  onRemove,
}: OperatorsListProps) {
  const { translate } = useLang()


  if (!operatorsList || operatorsList.length === 0) {
    return (
      <Grid item xs={12}>
        <Typography variant="body2" color="text.secondary">
          {translate('No operators added yet')}
        </Typography>
      </Grid>
    )
  }

  return (
    <>
      {operatorsList.map((operator) => (
        <Grid item xs={6} key={operator.id}>
          <Paper
            elevation={1}
            sx={{
              p: 2,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography variant="body1">
              {operator?.registration ? `[${operator.registration}]` : ''} {operator?.representation_name || operator?.name || ''}
            </Typography>
            <IconButton
              color="error"
              onClick={() => onRemove(operator.id)}
              aria-label={translate('Remove operator')}
            >
              <DeleteIcon />
            </IconButton>
          </Paper>
        </Grid>
      ))}
    </>
  )
}
